import React, { FC } from 'react';
import { Box, BoxProps, Text, FormLabel } from '@chakra-ui/core';

export interface Props extends BoxProps {
  title: string;
  subTitle?: string;
}

export const DetailRow: FC<Props> = ({
  children,
  title,
  subTitle,
  ...props
}) => {
  return (
    <Box
      d="flex"
      flexDir="row"
      justifyContent="space-between"
      backgroundColor="white"
      borderTop="1px solid"
      borderColor="gray.500"
      py="2"
      px="6"
      minH="48px"
      h="48px"
      w="100%"
      {...props}
    >
      <Box flex="4" d="flex" flexDir="column" alignSelf="center">
        <FormLabel htmlFor={title}>
          <Text m="0" textAlign="left" fontWeight="bold" fontSize="12px">
            {title}
          </Text>
          {subTitle && (
            <Text m="0" textAlign="left" fontSize="11px">
              {subTitle}
            </Text>
          )}
        </FormLabel >
      </Box>
      <Box d="flex" justifyContent="flex-end" flex="1" alignSelf="center" marginRight="1">
        {children}
      </Box>
    </Box>
  );
};
